var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFarm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 8.41C34.4167 3.625 30.4792 0 25.5208 0C23.0417 0 20.5625 1.015 18.8125 2.755C17.7917 3.77 17.0625 4.785 16.625 6.09L24.7917 11.455V11.6H29.1667V14.5H24.7917V17.4H29.1667V20.3H24.7917V23.2H29.1667V26.1H24.7917V29H35V8.41ZM19.3958 7.25C20.2708 4.64 22.75 2.9 25.5208 2.9C28.2917 2.9 30.7708 4.64 31.6458 7.25H19.3958ZM0 13.05V29H7.29167V18.85H14.5833V29H21.875V13.05L10.9375 5.8L0 13.05Z",
    fill: "#454545"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFarm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/farm.d5d0c4440eef39effb2a8342989dd4a1.svg";